import {DrugItemColumnsDef} from '@/modules/drug-catalog/components/table-columns'
import {DisplayColDef} from '@cypro/ui/types'
import {chakra} from '@chakra-ui/react'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {createColumnHelper} from '@tanstack/react-table'
import {useTranslate} from '@tolgee/react'
import {LuPencil} from 'react-icons/lu'
import {useNavigate} from '@tanstack/react-router'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {useCan} from '@/shared/hooks/use-permissions'

export const substancesColumnHelper = createColumnHelper<DrugCatalogItem>()

// type AccessorColumnDef = AccessorColDef<DrugCatalogItem>
type DisplayColumnDef = DisplayColDef<DrugCatalogItem>

export const ActiveSubstancesColumnsDef = {
  ...DrugItemColumnsDef,

  viewPage: (def?: DisplayColumnDef) =>
    substancesColumnHelper.display({
      id: 'view=page',
      header: () => {
        return null
      },
      cell: ({row}) => {
        const navigate = useNavigate()
        const canEdit = useCan('catalogue.manage')
        if (!canEdit) return null

        const linkProps = {
          to: '/configuration/drug-catalog/active-substances/new',
          search: {substanceId: row.original.id},
        } as const

        function onKeyDown(e: React.KeyboardEvent) {
          if (e.code === 'Enter' || e.code === 'Space') {
            e.preventDefault()
            e.stopPropagation()
            navigate(linkProps)
          }
        }
        return (
          <LinkButton {...linkProps} variant="ghost" size="sm" onClick={e => e.stopPropagation()} onKeyDown={onKeyDown}>
            <LuPencil />{' '}
          </LinkButton>
        )
      },
      ...def,
    }),
  doseCalculationMethod: (def?: DisplayColumnDef) =>
    substancesColumnHelper.display({
      id: 'doseCalcMode',
      header: () => {
        const {t} = useTranslate('common')
        return (
          <chakra.div display="flex" justifyContent="flex-end" width="100%">
            {t('calculation')}
          </chakra.div>
        )
      },
      cell: ({row}) => {
        const {t} = useTranslate('common')
        const doseCalcMode = row.original.activeSubstanceDetails?.doseCalcMode
        if (!doseCalcMode) return null
        return (
          <chakra.div display="flex" justifyContent="flex-end" width="100%" color="fg.muted">
            {t(doseCalcMode)}
          </chakra.div>
        )
      },
      ...def,
    }),

  doseUnit: (def?: DisplayColumnDef) =>
    substancesColumnHelper.display({
      id: 'doseUnit',
      header: () => {
        const {t} = useTranslate('common')
        return <chakra.div>{t('unit')}</chakra.div>
      },
      cell: ({row}) => {
        if (!row.original.activeSubstanceDetails?.doseUnit) return null
        return <chakra.div color="fg.muted">{row.original.activeSubstanceDetails?.doseUnit.ucumCode}</chakra.div>
      },
      ...def,
    }),
}
